import React from 'react';
import { useTheme } from '../../contexts/ThemeContext.tsx';
import type { AttendanceSummary } from './useContactAttendanceSummary.ts';

export default function AttendanceBadge({ humanMode, summary }: { humanMode: boolean; summary: AttendanceSummary | null }) {
  const { isDark } = useTheme();
  const name = summary?.enabled ? summary.owner?.name?.trim() : undefined;
  const label = name || (humanMode ? 'Humano' : 'IA');
  const description = name ? `${name} — ${humanMode ? 'atendimento humano' : 'IA respondendo'}` : label;
  return (
    <span aria-label={`Atendimento: ${description}`} title={description} className={`inline-flex min-w-0 max-w-full items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold leading-4 ${humanMode
      ? isDark ? 'border-rose-800 bg-rose-950/50 text-rose-300' : 'border-rose-200 bg-rose-50 text-rose-700'
      : 'border-sminy-primary/20 bg-sminy-primary/10 text-sminy-primary'}`}>
      <span className="truncate">{label}</span>
    </span>
  );
}
